export { isRecargasPlan, parseAgentSeats, RECARGAS_PLAN_ID, zeroQuotaIsCap, type AgentSeats } from "../../supabase/functions/_shared/credits-plan";

export type CreditPlanOfferReason = "unknown" | "etb" | "no_charge" | "on_recargas" | "no_plan" | "plan_cancelled" | "explora_exhausted" | "has_plan";

export interface CreditPlanOffer {
  organizationId: string | null;
  eligible: boolean;
  reason: CreditPlanOfferReason;
}

const REASONS: CreditPlanOfferReason[] = ["unknown", "etb", "no_charge", "on_recargas", "no_plan", "plan_cancelled", "explora_exhausted", "has_plan"];

const OFFERED: CreditPlanOfferReason[] = ["no_plan", "plan_cancelled", "explora_exhausted"];

export function parseCreditPlanOffer(raw: unknown): CreditPlanOffer | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const row = raw as Record<string, unknown>;
  const reason = REASONS.find((candidate) => candidate === row.reason);
  if (!reason) return null;
  const eligible = row.eligible === true && OFFERED.includes(reason);
  return {
    organizationId: typeof row.organization_id === "string" ? row.organization_id : null,
    eligible,
    reason,
  };
}

const ACCEPT_ERRORS: Record<string, string> = {
  "42501": "Solo un administrador o supervisor de la cuenta puede elegir el plan.",
  "22023": "El pago con créditos ya no está disponible para esta cuenta. Recarga la página.",
  "55000": "La cuenta todavía tiene un débito automático activo. Cancela tu suscripción antes de pasar a pagar con créditos.",
  "55P03": "Tu plan actual tiene consumo pendiente de pago. Págalo antes de pasar a pagar con créditos.",
  RCG02: "El pago con créditos no está disponible para esta cuenta. Escríbenos a soporte.",
};

export function creditPlanAcceptErrorMessage(error: { code?: string | null } | null | undefined): string {
  return (error?.code && ACCEPT_ERRORS[error.code]) || "No pudimos activar el pago con créditos. No se cambió nada; intenta de nuevo.";
}

export interface RecargasSummary {
  organizationId: string | null;
  onRecargas: boolean;
  enrolled: boolean;
  balanceCop: number;
  priceCop: number | null;
  extrasLeft: number;
}

export function parseRecargasSummary(raw: unknown): RecargasSummary | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const row = raw as Record<string, unknown>;
  const price = row.price_cop === null || row.price_cop === undefined ? null : Number(row.price_cop);
  return {
    organizationId: typeof row.organization_id === "string" ? row.organization_id : null,
    onRecargas: row.on_recargas === true,
    enrolled: row.enrolled === true,
    balanceCop: Number.isFinite(Number(row.balance_cop)) ? Number(row.balance_cop) : 0,
    priceCop: price !== null && Number.isFinite(price) ? price : null,
    extrasLeft: Number.isFinite(Number(row.extras_left)) ? Math.max(0, Number(row.extras_left)) : 0,
  };
}

export function recargasCanAnswer(summary: Pick<RecargasSummary, "balanceCop" | "priceCop" | "extrasLeft">): boolean {
  if (summary.extrasLeft > 0) return true;
  return summary.priceCop !== null && summary.balanceCop >= summary.priceCop;
}
